enum CalendarWidth {
  DEFAULT = 'default-width',
  FULL_WIDTH = 'full-width',
}

enum DatePickerType {
  DROP_DOWN = 'dropdown',
  MODAL = 'modal',
}

enum CalendarType {
  DEFAULT = 'default',
  MONTH_YEAR_SELECTOR = 'month_year_selector',
  ONLY_MONTH_YEAR_SELECTOR = 'only_month_year_selector',
}
enum SelectorType {
  MONTH = 'month',
  YEAR = 'year',
}
enum TimePickerModal {
  NONE = 'none',
  START_TIME = 'start-time',
  END_TIME = 'end-time',
}

enum PrimaryButtonLabel {
  APPLY = 'Apply',
  CLEAR = 'Clear',
}

enum TimeMeridiem {
  AM = 'AM',
  PM = 'PM',
}

enum DatePickerValidataionStatus {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
enum CalendarYearDropdownType {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}
enum DateFormat {
  DDMMYYYY = 'DD/MM/YYYY',
  DDMMMYYYY = 'DD MMM YYYY',
  MMDDYYYY = 'MM/DD/YYYY',
  YYYYMMDD = 'YYYY/MM/DD',
  YYYYMMDD_JP = 'YYYY年 MM月 DD日',
  YYYYMM = "'YYYY/MM",
}
export {
  DatePickerType,
  TimePickerModal,
  PrimaryButtonLabel,
  CalendarWidth,
  TimeMeridiem,
  DatePickerValidataionStatus,
  CalendarYearDropdownType,
  DateFormat,
  CalendarType,
  SelectorType,
};
